import { getDataMapper, mapField } from "@/shared";

export const mapRefusalTypeToServer = getDataMapper({
    title: mapField("title"),
});
